import type { Vehicle } from '../../Entities/Vehicle/Vehicle.entity';

export const navigateToCheckout = (
  router: any,
  vehicle: Vehicle,
  hasDealerCash: boolean,
  hasVtiCash: boolean,
): boolean => {
  const checkoutId = `checkout/${vehicle.heycarId}`;
  if (hasDealerCash) {
    router?.push(`/${checkoutId}/dealer/about-you`);
    return true;
  }
  if (hasVtiCash) {
    router?.push(`/${checkoutId}/vti-cash/about-you`);
    return true;
  }
  return false;
};
